import React, { useContext, useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
// import Navbar from "react-bootstrap/Navbar";
// import Dropdown from "react-bootstrap/Dropdown";
// import NavDropdown from "react-bootstrap/NavDropdown";
// import logo from '../images/logobit.png';
import logo from "../images/bitlogoimg.svg";
import WalletLogo from "../community/images/walletLogo.png";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
import { Spinner } from "react-bootstrap";
// import { KeyStore } from "near-api-js/lib/key_stores";
import "../Component/DashboardHeader.css";
import axios from "axios";
import { APIURI, NftMarketplace, apiConfig } from "../config";
// import { LocalHospitalTwoTone } from "@material-ui/icons";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Menu from "@mui/material/Menu";
import MenuIcon from "@mui/icons-material/Menu";
import Container from "@mui/material/Container";
// import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import Tooltip from "@mui/material/Tooltip";
import MenuItem from "@mui/material/MenuItem";
// import AdbIcon from "@mui/icons-material/Adb";
import Swal from "sweetalert2";
import AppBar from "@mui/material/AppBar";
import {
  bithappierWalletContext,
  ProfileImageContext,
  userNameContext,
  walletBalanceContext,
  usdAmountContext,
} from "../Context/HappinessResChange";
import Cookies from "universal-cookie";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import copy from "copy-to-clipboard";
import { DecodingString } from "../helperFunction/DecodingString";

const nearAPI = require("near-api-js");
const pages = [
  {
    heading: "Dashboard",
    link: "/professionaldashboard",
  },
  // {
  //   heading: "Happiness Goals",
  //   link: "/homepage",   // excel change
  // },
  // {
  //   heading: "Happiness Experiences", // excel change
  //   link: "/marketplace",
  // },
  // {
  //   heading: 'Wellness Based Art',
  //   link: '/marketplace',
  // },
];

const ProfessionalHeader = ({ stripeConnectionStatus }) => {
  const cookies = new Cookies();
  const [anchorElNav, setAnchorElNav] = React.useState(null);
  const [anchorElUser, setAnchorElUser] = React.useState(null);
  const [wallet, setWallet] = useState();
  const [profileImage, setProfileImage] = useContext(ProfileImageContext);
  const [userName, setUserName] = useContext(userNameContext);
  const [bithappierWallet, setBithappierWallet] = useContext(
    bithappierWalletContext
  );
  const [sendLoad, setSendLoad] = useState(false);
  const [usdAmount, setUsdAmount] = useContext(usdAmountContext);
  const [notificationNumber, setNotificationNumber] = useState("0");
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [walletBallance, setWalletBallance] = useContext(walletBalanceContext);
  const [openBuyNearModal, setOpenBuyNearModal] = useState(false);
  const [openBuyNearWithusModal, setOpenBuyNearWithusModal] = useState(false);
  const [isCopied, setIsCopied] = useState(false);
  const [isNotificationPage, setIsNotificationPage] = useState(false);
  // const roleType = DecodingString(cookies.get('_ssUuId', { path: '/' }));
  // {
  //   console.log(roleType);
  // }
  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };
  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const settingsWithGetCredential = [
    {
      heading: "Profile",
      link: "/myprofile",
    },
    {
      heading: "Happiness Wallet",
      link: "/connectwallet",
    },
    {
      heading: `Notifications   
      ${isNotificationPage
          ? ""
          : `
        <span class=${notificationNumber !== "0" ? "notification--icon" : ""}>${notificationNumber === "0" ? "" : notificationNumber
          }</span>
        `
        }
      `,
      link: "/notification",
    },
    {
      heading: "Export NEAR Private Key",
    },
    {
      heading: "Buy Near",
    },
    {
      heading: stripeConnectionStatus === "VERIFIED" ? "Stripe Connected" : "Connect Stripe",
    },
    // {
    //   heading: "Appointment",
    //   link: "/yourappointments",
    // },
    // {
    //   heading: "Happiness Goal",  //excel changes
    //   link: "/homepage",
    // },
    // {
    //   heading: "Community",
    //   link: "/community",
    // },
    // {
    //   heading: "Leaderboard",
    //   link: "/leaderboard",
    // },
    // {
    //   heading: "Market Place",
    //   link: "/marketplace",
    // },
    // {
    //   heading: 'Wallness Based Art',
    //   link: '/marketplace',
    // },
    // {
    //   heading: "Happiness Experiences", // excel change
    //   link: "/marketplace",
    // },
    {
      heading: "Change Password",
      link: "/editpassword",
    },
    {
      heading: "Delete Your Account",
      link: "/delete-your-account",
    },
    {
      heading: "Log out",
      link: "/",
    },
  ];

  const settingsWithOutGetCredential = [
    {
      heading: "Profile",
      link: "/myprofile",
    },
    {
      heading: "Wallet",
      link: "/connectwallet",
    },
    {
      heading: `Notifications   
      ${isNotificationPage
          ? ""
          : `<span class=${notificationNumber !== "0" ? "notification--icon" : ""
          }>${notificationNumber === "0" ? "" : notificationNumber}</span>`
        }
      `,
      link: "/notification",
    },
    // {
    //   heading: "Appointment",
    //   link: "/yourappointments",
    // },
    // {
    //   heading: "Happiness Goal",   // excel change
    //   link: "/homepage",
    // },
    // {
    //   heading: "Community",
    //   link: "/community",
    // },
    // {
    //   heading: "Leaderboard",
    //   link: "/leaderboard",
    // },
    {
      heading: "Market Place",
      link: "/marketplace",
    },
    {
      heading: "Change Password",
      link: "/editpassword",
    },
    {
      heading: "Log out",
      link: "/",
    },
  ];

  // const settingsWithOutGetCredentialForCorporate = [
  //   {
  //     heading: 'Profile',
  //     link: '/myprofile',
  //   },
  //   {
  //     heading: 'Wallet',
  //     link: '/connectwallet',
  //   },
  //   {
  //     heading: `Notifications
  //     <span class=${notificationNumber !== '0' ? 'notification--icon' : ''}>${
  //       notificationNumber === '0' ? '' : notificationNumber
  //     }</span>`,
  //     link: '/notification',
  //   },
  //   {
  //     heading: 'Happiness Goal',
  //     link: '/homepage',
  //   },
  //   {
  //     heading: 'Market Place',
  //     link: '/marketplace',
  //   },
  //   {
  //     heading: 'Change Password',
  //     link: '/editpassword',
  //   },
  //   {
  //     heading: 'Log out',
  //     link: '/',
  //   },
  // ];

  // const settingsWithGetCredentialForCorporate = [
  //   {
  //     heading: 'Profile',
  //     link: '/myprofile',
  //   },
  //   {
  //     heading: 'Happiness Wallet',
  //     link: '/connectwallet',
  //   },
  //   {
  //     heading: `Notifications
  //     <span class=${notificationNumber !== '0' ? 'notification--icon' : ''}>${
  //       notificationNumber === '0' ? '' : notificationNumber
  //     }</span>`,
  //     link: '/notification',
  //   },
  //   {
  //     heading: 'Export NEAR Private Key',
  //   },
  //   {
  //     heading: 'Buy Near',
  //   },
  //   {
  //     heading: 'Happiness Goal',
  //     link: '/homepage',
  //   },
  //   {
  //     heading: 'Happiness Based Art',
  //     link: '/marketplace',
  //   },
  //   {
  //     heading: 'Change Password',
  //     link: '/editpassword',
  //   },
  //   {
  //     heading: 'Log out',
  //     link: '/',
  //   },
  // ];

  // // nav bar popup renderProfileOption
  // const renderProfileOption = () => {
  //   if (roleType === 'ROLE_CORPORATE') {
  //     // options for corporate user
  //     if (bithappierWallet) {
  //       return settingsWithGetCredentialForCorporate.map((setting, index) => (
  //         <Link
  //           to={
  //             setting.heading === 'Wallet'
  //               ? accountId || bithappierWallet
  //                 ? '/wallet'
  //                 : setting.link
  //               : setting.link
  //           }
  //           key={index}
  //           className="navbar-links"
  //           onClick={() => {
  //             handlelogoutOption(setting.heading);
  //           }}
  //         >
  //           <MenuItem
  //             onClick={handleCloseUserMenu}
  //             className="menu--item--header"
  //           >
  //             <Typography
  //               textAlign="center"
  //               onClick={(e) => {
  //                 handleGetCredential(e, setting.heading);
  //               }}
  //             >
  //               <div
  //                 dangerouslySetInnerHTML={{
  //                   __html: setting.heading,
  //                 }}
  //               />
  //             </Typography>
  //           </MenuItem>
  //         </Link>
  //       ));
  //     } else {
  //       return settingsWithOutGetCredentialForCorporate.map(
  //         (setting, index) => (
  //           <Link
  //             to={
  //               setting.heading === 'Wallet'
  //                 ? accountId || bithappierWallet
  //                   ? '/wallet'
  //                   : setting.link
  //                 : setting.link
  //             }
  //             key={index}
  //             className="navbar-links"
  //             onClick={() => {
  //               handlelogoutOption(setting.heading);
  //             }}
  //           >
  //             <MenuItem
  //               onClick={handleCloseUserMenu}
  //               className="menu--item--header"
  //             >
  //               <Typography textAlign="center">
  //                 <div
  //                   dangerouslySetInnerHTML={{
  //                     __html: setting.heading,
  //                   }}
  //                 />
  //               </Typography>
  //             </MenuItem>
  //           </Link>
  //         )
  //       );
  //     }
  //   } else {
  //     // options for normal_user & therapist
  //     if (bithappierWallet) {
  //       return settingsWithGetCredential.map((setting, index) => (
  //         <Link
  //           to={
  //             setting.heading === 'Wallet'
  //               ? accountId || bithappierWallet
  //                 ? '/wallet'
  //                 : setting.link
  //               : setting.link
  //           }
  //           key={index}
  //           className="navbar-links"
  //           onClick={() => {
  //             handlelogoutOption(setting.heading);
  //           }}
  //         >
  //           <MenuItem
  //             onClick={handleCloseUserMenu}
  //             className="menu--item--header"
  //           >
  //             <Typography textAlign="center">
  //               <div
  //                 dangerouslySetInnerHTML={{
  //                   __html: setting.heading,
  //                 }}
  //               />
  //             </Typography>
  //           </MenuItem>
  //         </Link>
  //       ));
  //     } else {
  //       return settingsWithOutGetCredential.map((setting, index) => (
  //         <Link
  //           to={
  //             setting.heading === 'Wallet'
  //               ? accountId || bithappierWallet
  //                 ? '/wallet'
  //                 : setting.link
  //               : setting.link
  //           }
  //           key={index}
  //           className="navbar-links"
  //           onClick={() => {
  //             handlelogoutOption(setting.heading);
  //           }}
  //         >
  //           <MenuItem
  //             onClick={handleCloseUserMenu}
  //             className="menu--item--header"
  //           >
  //             <Typography textAlign="center">
  //               <div
  //                 dangerouslySetInnerHTML={{
  //                   __html: setting.heading,
  //                 }}
  //               />
  //             </Typography>
  //           </MenuItem>
  //         </Link>
  //       ));
  //     }
  //   }
  // };

  const navigate = useNavigate();
  const token = cookies.get("isLoggedIn", { path: "/" });
  const location = useLocation();
  const handleSend = (e) => {
    setSendLoad(true);
    axios
      .post(
        `${APIURI}api/user/send-key-mailer`,
        "accept: */*",
        apiConfig
        // {
        //   headers: { Authorization: `Bearer ${token}` },
        // }
      )
      .then((res) => {
        // console.log(res);
        if (res.status === 200) {
          handleClose();
          setSendLoad(false);
          Swal.fire({
            title: "Sent!",
            text: "The link to your NEAR Wallet private key has been sent to your registered Email Id",
            icon: "success",
            confirmButtonText: "OK",
          });
        }
      })
      .catch((err) => {
        // console.log(err);
        setSendLoad(false);
      });
  };

  const userId = cookies.get("userId", { path: "/" });
  const therapistId = cookies.get("therapistId", { path: "/" })
  // console.log(userId);
  const { pathname } = location;
  const splitLocation = pathname.split("/");
  if (splitLocation[1] === "") console.log(wallet);
  // const notify = () => toast("Wallet added Successfully!");
  let accountId;
  if (localStorage.near_app_wallet_auth_key) {
    accountId = JSON.parse(localStorage.near_app_wallet_auth_key).accountId;
    // console.log(accountId);
  } else if (bithappierWallet) {
    accountId = `${bithappierWallet}.${process.env.REACT_APP_NEAR_WALLET_SUFFIX}`;
  }
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    border: "2px solid transparent",
    borderRadius: "12px",
    bgcolor: "#f8f8f8",
    boxShadow: " 0px 4px 34px 0px #00000040",
    width: { xs: "95%", md: 600, lg: 700 },
  };

  async function Connectwallet() {
    const { connect, keyStores, WalletConnection, KeyPair, utils } = nearAPI;

    const keyStore = new keyStores.BrowserLocalStorageKeyStore();
    // console.log(keyStore);
    // const config = {
    //   networkId: "testnet",
    //   keyStore,
    //   nodeUrl: "https://rpc.testnet.near.org",
    //   walletUrl: "https://wallet.testnet.near.org",
    //   helperUrl: "https://helper.testnet.near.org",
    //   explorerUrl: "https://explorer.testnet.near.org",
    // };
    const config = {
      networkId: process.env.REACT_APP_NEAR_NETWORK,
      keyStore: keyStore, // first create a key store
      nodeUrl: `https://rpc.${process.env.REACT_APP_NEAR_NETWORK}.near.org`,
      walletUrl: process.env.REACT_APP_NEAER_WALLET_URL,
      helperUrl: `https://helper.${process.env.REACT_APP_NEAR_NETWORK}.near.org`,
      explorerUrl: `https://explorer.${process.env.REACT_APP_NEAR_NETWORK}.near.org`,
    };
    const near = await connect(config);
    // console.log(near);
    const wallet = new WalletConnection(near);
    // console.log(wallet);

    // returns account Id as string
    const walletAccountId = wallet.getAccountId();
    if (wallet.isSignedIn()) {
      // console.log("signed in");
    }
    // console.log(walletAccountId, "hello");
    setWallet(walletAccountId);
  }
  const handleSubmit = (e) => {
    if (accountId) {
      // setBuyNearBtnLoad(true);
      axios
        .post(
          `${NftMarketplace}/near/sign?userId=${accountId}`,
          "accept: */*",
          apiConfig
          // {
          //   headers: { Authorization: `Bearer ${token}` },
          // }
        )
        .then((res) => {
          // setSignature(res.data.sign);
          // console.log(res);
          // setBuyNearBtnLoad(false);
          if (res.status === 200) {
            window.open(
              `https://widget.munzen.io/?apiKey=8b22664e-05b1-4c16-bfe2-c8c7169d62e3&toCurrency=NEAR&toWallet=${accountId}&merchantOrderId=${userId}&signature=${res.data.sign}`,
              "_blank"
            );
          }
        });
    } else {
      Swal.fire({
        title: "Please connect your near wallet!",
        confirmButtonText: "Connect wallet",
      }).then((swalres) => {
        navigate("/connectwallet");
      });
    }
  };
  const handleLogout = () => {
    // cookies.remove();
    setBithappierWallet(null);
    axios.post(`${APIURI}api/user/logout`, null, apiConfig).then((res) => {
      // console.log(res);
      // console.log("logout successfully");
    });
    setBithappierWallet(null);
    document.cookie.split(";").forEach(function (c) {
      document.cookie = c
        .replace(/^ +/, "")
        .replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=*");
      document.cookie = c
        .replace(/^ +/, "")
        .replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
    });
    const cookies1 = document.cookie.split(";");

    for (let i = 0; i < cookies1.length; i++) {
      const cookie1 = cookies1[i];
      const eqPos = cookie1.indexOf("=");
      const name = eqPos > -1 ? cookie1.substr(0, eqPos) : cookie1;
      document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
    }
    localStorage.clear();
    cookies.remove("jwtToken", { path: "/" });
    cookies.remove("isLoggedIn", { path: "/" });
    // cookies.remove("role_type", { path: "/" });
    // cookies.remove("userId", { path: "/" });
    // cookies.remove("uuid", { path: "/" });
    // cookies.remove("thisissomething", { path: "/" });
    // cookies.remove("threadId", { path: "/" });
    // cookies.remove("isWalletConnected", { path: "/" });
    // cookies.remove("therapist_appointment_details", { path: "/" });
    // cookies.remove({ path: "/", domain: "https://testnet.bithappier.com/" });
    localStorage.clear();
    cookies.remove("jwtToken");
    Swal.fire({
      title: "Success",
      text: "Logged out succesfully!",
      icon: "success",
      confirmButtonText: "OK",
      timer: 1000,
    });
    setProfileImage(null);
    navigate("/login");
  };

  const tokenExpired = () => {
    // cookies.remove();
    setBithappierWallet(null);
    axios.post(`${APIURI}api/user/logout`, null, apiConfig).then((res) => {
      // console.log(res);
      // console.log("logout successfully");
    });
    document.cookie.split(";").forEach(function (c) {
      document.cookie = c
        .replace(/^ +/, "")
        .replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=*");
      document.cookie = c
        .replace(/^ +/, "")
        .replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
    });
    const cookies1 = document.cookie.split(";");

    for (let i = 0; i < cookies1.length; i++) {
      const cookie1 = cookies1[i];
      const eqPos = cookie1.indexOf("=");
      const name = eqPos > -1 ? cookie1.substr(0, eqPos) : cookie1;
      document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
    }
    localStorage.clear();
    cookies.remove("jwtToken", { path: "/" });
    cookies.remove("isLoggedIn", { path: "/" });
    // cookies.remove("role_type", { path: "/" });
    // cookies.remove("userId", { path: "/" });
    // cookies.remove("uuid", { path: "/" });
    // cookies.remove("thisissomething", { path: "/" });
    // cookies.remove("threadId", { path: "/" });
    // cookies.remove("isWalletConnected", { path: "/" });
    // cookies.remove("therapist_appointment_details", { path: "/" });
    // cookies.remove({ path: "/", domain: "https://testnet.bithappier.com/" });
    localStorage.clear();
    Swal.fire({
      title: "Session Expired !",
      text: "Please login again.",
      icon: "error",
      confirmButtonText: "OK",
      // timer: 1000,
    });
    setProfileImage(null);
    navigate("/login");
  };
  useEffect(() => {
    setIsNotificationPage(window.location.href.includes("/notification"));
    axios
      .get(
        `${APIURI}api/user/get-read-notification`,
        apiConfig
        //  {
        //   headers: { Authorization: `Bearer ${token}` },
        // }
      )
      .then((res) => {
        // console.log(res);
        setNotificationNumber(res.data.data.read);
      })
      .catch((err) => {
        // console.log(err);
        // if (err.response.status === 401) {
        tokenExpired();
        // }
      });
  }, []);
  useEffect(() => {
    Connectwallet();
    // console.log(wallet);
  }, [wallet]);
  if (!token) {
    navigate("/login");
  }
  const handlelogoutOption = (heading) => {
    if (heading === "Log out") {
      handleLogout();
      handleCloseNavMenu();
    } else if (heading === "Wallet" || heading === "Happiness Wallet") {
      const path = window.location.pathname;
      document.cookie = "currentURL=" + encodeURIComponent(path);
      console.log(document.cookie);
    }
  };
  const handleGetCredential = (e, heading) => {
    if (heading === "Export NEAR Private Key") {
      handleOpen();
    } else if (heading === "Buy Near") {
      console.log("buy near");
      // console.log("buy near");
      // setOpenBuyNearModal(true);
      // navigate("/buy-near");
      window.location.href = "/buy-near";
    } else if (heading === "Connect Stripe") {
      axios.post(`${APIURI}api/v1/stripe/get-account-onboarding-link`, {
        "referenceId": therapistId,
        "referenceType": "THERAPIST"
      }, apiConfig)
        .then((res) => {
          console.log(res)
          window.location.href = res.data.data.onboardingLink;
        }
        ).catch((err) => {
          console.log(err)
          Swal.fire({
            title: "Error",
            text: "Something went wrong",
            icon: "error",
            confirmButtonText: "OK",
          });
        })
    }
  };
  const handlePriceWithDecimals = (price) => {
    price = price.toString();
    if (price.includes(".")) {
      let pontArry = price.split(".");
      return pontArry[0] + "." + pontArry[1].slice(0, 3);
    } else {
      return price;
    }
  };

  const isLoggedIn = cookies.get("isLoggedIn") === 'true';

  return (
    <>
      {/* buyNear modal  */}
      {/* <Modal
        open={openBuyNearModal}
        onClose={() => {
          setOpenBuyNearModal(false);
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="fitbit-modal"
      >
        <Box sx={style}>
          <div className="p-4">
            <div className="d-flex justify-content-end">
              <button
                style={{
                  background: "transparent",
                  fontWeight: "600",
                  border: "none",
                  outline: "none",
                  fontSize: "22px",
                }}
                onClick={() => {
                  setOpenBuyNearModal(false);
                }}
              >
                X
              </button>
            </div>
            <div className="d-flex flex-column align-items-center">
              <button
                className="d-flex flex-column align-items-center btn buy--near--btn"
                onClick={() => {
                  handleSubmit();
                }}
              >
                Buy Near via NearPay <span>(Only for European Cutomers)</span>
              </button>
              <h6>OR</h6>
              <h5>Add Near to your wallet via following platforms</h5>
              <h5>
                Your wallet Address :{" "}
                <span style={{ color: "#7637fd" }}>{accountId}</span>{" "}
                <button
                  className="btn"
                  onClick={() => {
                    copy(accountId);
                    setIsCopied(true);
                    setTimeout(() => {
                      setIsCopied(false);
                    }, 3000);
                  }}
                >
                  {isCopied ? "Copied!" : <ContentCopyIcon />}
                </button>
              </h5>
              <p className="text-danger">
                Please copy you wallet address as you would require at the time
                of buying
              </p>
              <div className="row flex-wrap">
                <div className="col-6">
                  <button
                    className="row d-flex align-items-center mx-2 btn buy--near--btn2"
                    onClick={() => {
                      window.open("https://checkout.banxa.com/", "_blank");
                    }}
                  >
                    <div className="col-6">
                      <img
                        src="/./images/banax.svg"
                        alt=""
                        srcset=""
                        style={{ width: "90%" }}
                      />
                    </div>
                    <div className="d-flex col-6 flex-column align-items-center">
                      Banxa
                    </div>
                  </button>
                </div>
                <div className="col-6">
                  <button
                    className="row d-flex align-items-center mx-2 btn buy--near--btn2"
                    onClick={() => {
                      window.open("https://buy.onramper.com/", "_blank");
                    }}
                  >
                    <div className="col-6">
                      <img
                        src="/./images/onramper.svg"
                        alt=""
                        srcset=""
                        style={{ width: "90%" }}
                      />
                    </div>
                    <div className="col-6 d-flex flex-column align-items-center">
                      OnRamper
                    </div>
                  </button>
                </div>
                <div className="col-6">
                  <button
                    className="row d-flex align-items-center mx-2 btn buy--near--btn2"
                    onClick={() => {
                      window.open("https://www.moonpay.com/buy", "_blank");
                    }}
                  >
                    <div className="col-6">
                      <img
                        src="/./images/moonpay.svg"
                        alt=""
                        srcset=""
                        style={{ width: "90%" }}
                      />
                    </div>
                    <div className="d-flex col-6 flex-column align-items-center">
                      MoonPay
                    </div>
                  </button>
                </div> */}
      {/* <div className="col-6">
                  <button
                    className="row d-flex align-items-center mx-2 btn buy--near--btn2"
                    onClick={() => {
                      window.open(
                        "https://www.binance.com/en/price/near-protocol",
                        "_blank"
                      );
                    }}
                  >
                    <div className="col-6">
                      <img
                        src="/./images/binance.svg"
                        alt=""
                        srcset=""
                        style={{ width: "90%" }}
                      />
                    </div>
                    <div className="d-flex col-6 flex-column align-items-center">
                      Binance
                    </div>
                  </button>
                </div> */}
      {/* <div className="col-6">
                  {" "}
                  <button
                    className="row d-flex align-items-center mx-2 btn buy--near--btn2"
                    onClick={() => {
                      window.open(
                        "https://www.coinbase.com/price/near-protocol",
                        "_blank"
                      );
                    }}
                  >
                    <div className="col-6">
                      {" "}
                      <img
                        src="/./images/coinbase.svg"
                        alt=""
                        srcset=""
                        style={{ width: "90%" }}
                      />
                    </div>
                    <div className="d-flex col-6 flex-column align-items-center">
                      Coinbase
                    </div>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Box>
      </Modal> */}

      {/* buyNear modal  */}
      <Modal
        open={openBuyNearModal}
        onClose={() => {
          setOpenBuyNearModal(false);
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="fitbit-modal"
      >
        <Box sx={style}>
          <div className="p-4">
            <div className="d-flex justify-content-end">
              <button
                style={{
                  background: "transparent",
                  fontWeight: "600",
                  border: "none",
                  outline: "none",
                  fontSize: "22px",
                }}
                onClick={() => {
                  setOpenBuyNearModal(false);
                }}
              >
                X
              </button>
            </div>
            <div className="d-flex flex-column align-items-center">
              <button
                className="d-flex flex-column align-items-center btn buy--near--btn hideForEuropean"
                onClick={() => {
                  handleSubmit();
                  setOpenBuyNearModal(false);
                }}
              >
                Buy Near via NearPay <span>(Only for European Cutomers)</span>
              </button>
              <button
                className="d-flex flex-column align-items-center btn buy--near--btn mt-3"
              // onClick={() => {
              //   setOpenBuyNearWithusModal(true);
              // }}
              >
                Buy NEAR With Us
              </button>
              {/* <h6 className='mt-3'>OR</h6> */}
              <div
                className="d-flex flex-column mt-3 mb-2 position-relative"
                style={{ width: "100%" }}
              >
                <p className="position-absolute buy--near--or--para">OR</p>
                <div style={{ border: "1px solid #9F9F9F" }}></div>
              </div>
              <h5 style={{ margin: "10px 0px" }}>
                Add Near to your wallet via following platforms
              </h5>
              <h5
                style={{
                  backgroundColor: "#F2F2F2",
                  borderRadius: "7px",
                  padding: "6px",
                }}
              >
                Your wallet Address :{" "}
                <span style={{ color: "#7637fd" }}>{accountId}</span>{" "}
                <button
                  className="btn"
                  onClick={() => {
                    copy(accountId);
                    setIsCopied(true);
                    setTimeout(() => {
                      setIsCopied(false);
                    }, 3000);
                  }}
                >
                  {isCopied ? "Copied!" : <ContentCopyIcon />}
                </button>
              </h5>
              <p className="text-danger">
                Please copy you wallet address as you would require at the time
                of buying
              </p>
              <div className="row flex-wrap flex-row mt-3">
                <div className="col-6">
                  <button
                    className="row d-flex align-items-center mx-2 btn buy--near--btn2"
                    onClick={() => {
                      window.open("https://checkout.banxa.com/", "_blank");
                    }}
                  >
                    <div className="col-6">
                      <img
                        src="/./images/banax.svg"
                        alt=""
                        srcset=""
                        style={{ width: "90%" }}
                      />
                    </div>
                    <div className="d-flex col-6 flex-column align-items-center">
                      Banax
                    </div>
                  </button>
                </div>
                <div className="col-6">
                  <button
                    className="row d-flex align-items-center mx-2 btn buy--near--btn2"
                    onClick={() => {
                      window.open("https://buy.onramper.com/", "_blank");
                    }}
                  >
                    <div className="col-6">
                      <img
                        src="/./images/onramper.svg"
                        alt=""
                        srcset=""
                        style={{ width: "90%" }}
                      />
                    </div>
                    <div className="col-6 d-flex flex-column align-items-center">
                      OnRamper
                    </div>
                  </button>
                </div>
                <div className="col-6">
                  <button
                    className="row d-flex align-items-center mx-2 btn buy--near--btn2"
                    onClick={() => {
                      window.open("https://www.moonpay.com/buy", "_blank");
                    }}
                  >
                    <div className="col-6">
                      <img
                        src="/./images/moonpay.svg"
                        alt=""
                        srcset=""
                        style={{ width: "90%" }}
                      />
                    </div>
                    <div className="d-flex col-6 flex-column align-items-center">
                      MoonPay
                    </div>
                  </button>
                </div>
                {/* <div className="col-6">
                  <button
                    className="row d-flex align-items-center mx-2 btn buy--near--btn2"
                    onClick={() => {
                      window.open(
                        "https://www.binance.com/en/price/near-protocol",
                        "_blank"
                      );
                    }}
                  >
                    <div className="col-6">
                      <img
                        src="/./images/binance.svg"
                        alt=""
                        srcset=""
                        style={{ width: "90%" }}
                      />
                    </div>
                    <div className="d-flex col-6 flex-column align-items-center">
                      Binance
                    </div>
                  </button>
                </div> */}
                <div className="col-6">
                  {" "}
                  <button
                    className="row d-flex align-items-center mx-2 btn buy--near--btn2"
                    onClick={() => {
                      window.open(
                        "https://www.coinbase.com/price/near-protocol",
                        "_blank"
                      );
                    }}
                  >
                    <div className="col-6">
                      {" "}
                      <img
                        src="/./images/coinbase.svg"
                        alt=""
                        srcset=""
                        style={{ width: "90%" }}
                      />
                    </div>
                    <div className="d-flex col-6 flex-column align-items-center">
                      Coinbase
                    </div>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Box>
      </Modal>

      {/* buy near with us */}
      <Modal
        open={openBuyNearWithusModal}
        onClose={() => {
          setOpenBuyNearWithusModal(false);
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="fitbit-modal"
      >
        <Box sx={style}>
          <div className="p-4 buy--near--with--us--main--container">
            <div className="d-flex justify-content-end">
              <button
                style={{
                  background: "transparent",
                  fontWeight: "600",
                  border: "none",
                  outline: "none",
                  fontSize: "22px",
                }}
                onClick={() => {
                  setOpenBuyNearWithusModal(false);
                }}
              >
                X
              </button>
            </div>
            <div className="d-flex flex-column justify-content-center buy--near--with--us--popup--container">
              <h1 className="text-center">Buy NEAR with us</h1>
              <span>1 NEAR = 10$</span>
              <div className="d-flex flex-column justify-content-center buy--near--with--us--input--section mt-3 mb-5">
                <div className="mb-3 near--input1">
                  <input
                    type="text"
                    placeholder="NEAR = _____"
                    className="near--input2"
                    disabled
                  />
                </div>
                <div className="mb-3 near--input1">
                  <input
                    type="text"
                    placeholder="Amount = _____ (CAD)"
                    className="near--input2"
                    disabled
                  />
                </div>
                <div className="mt-3 d-flex flex-column near--input1">
                  <label htmlFor="" className="wallet-address-txt">
                    Wallet Address
                  </label>
                  <p
                    className="pt-1 near--input2"
                    style={{ marginBottom: "0px" }}
                  >
                    {accountId}
                  </p>
                  {/* <input
                    type="text"
                    placeholder={`rahulsharma.${process.env.REACT_APP_NEAR_WALLET_SUFFIX}`}
                    className="pt-1 near--input2"
                  /> */}
                </div>
              </div>
              <div
                className="d-flex flex-column"
                style={{ borderBottom: "2.73px solid #E4E4E4" }}
              >
                <h6 className="order-summary-txt">ORDER SUMMARY</h6>
                <div className="d-flex align-items-center justify-content-between total--payable--txt">
                  <h4>Total Payable</h4>
                  <span className="total--payable--price">CAD 100.00</span>
                </div>
              </div>
              <div className="d-flex flex-column mt-3 buy--near--with--us--imp--txt">
                <p>
                  * Your NEAR will be transferred in your wallet within next 24
                  hours.
                </p>
                <p>
                  * Rate set to the condition. Rate doesn't change drastically
                  while transferring the NEAR or the no. of NEAR for the amount
                  transferred will be transacted with the current price.
                </p>
              </div>
              <div className="mt-2 d-flex align-items-center justify-content-center">
                <button className="buy--near--with--us--btn">
                  Create Order
                </button>
              </div>
              <p
                className="pt-3 go--back--btn"
                onClick={() => {
                  setOpenBuyNearWithusModal(false);
                }}
              >
                Go Back
              </p>
            </div>
          </div>
        </Box>
      </Modal>

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="fitbit-modal"
      >
        <Box sx={style}>
          <div className="p-5">
            <div className="d-flex flex-column align-items-center get-credentials">
              <h4>Do you want to get credentials on your email??</h4>
              <div className="d-flex g-3">
                {sendLoad ? (
                  <button className="btn pe-2">
                    <Spinner
                      size="sm"
                      animation="border"
                      role="status"
                      style={{ marginRight: "0.7rem" }}
                    />
                    Yes
                  </button>
                ) : (
                  <button
                    className="btn pe-2"
                    onClick={(e) => {
                      handleSend(e);
                    }}
                  >
                    Yes
                  </button>
                )}
                <button
                  className="btn ms-2"
                  onClick={(e) => {
                    handleClose();
                  }}
                >
                  No
                </button>
              </div>
            </div>
          </div>
        </Box>
      </Modal>
      <AppBar position="static" className="material--ui--navbar-2">
        <Container maxWidth="xl">
          <Toolbar disableGutters>
            {/* <AdbIcon sx={{ display: { xs: 'none', md: 'flex' }, mr: 1 }} /> */}
            {
              isLoggedIn ? (
                <Typography
                  variant="h6"
                  noWrap
                  // component="a"
                  sx={{
                    mr: 2,
                    display: { xs: "none", md: "flex" },
                    fontFamily: "monospace",
                    fontWeight: 700,
                    letterSpacing: ".3rem",
                    color: "inherit",
                    textDecoration: "none",
                  }}
                >
                  <img
                    className="bithappier--header--logo"
                    src={logo}
                    alt="logo"
                  />
                </Typography>
              ) : (
                <Link to="/">
                  <Typography
                    variant="h6"
                    noWrap
                    // component="a"
                    sx={{
                      mr: 2,
                      display: { xs: "none", md: "flex" },
                      fontFamily: "monospace",
                      fontWeight: 700,
                      letterSpacing: ".3rem",
                      color: "inherit",
                      textDecoration: "none",
                    }}
                  >
                    <img
                      className="bithappier--header--logo"
                      src={logo}
                      alt="logo"
                    />
                  </Typography>
                </Link>
              )
            }


            <Box sx={{ flexGrow: 1, display: { xs: "flex", md: "none" } }}>
              <IconButton
                size="large"
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={handleOpenNavMenu}
                color="inherit"
              >
                <MenuIcon />
              </IconButton>
              <Menu
                id="menu-appbar"
                anchorEl={anchorElNav}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "left",
                }}
                keepMounted
                transformOrigin={{
                  vertical: "top",
                  horizontal: "left",
                }}
                open={Boolean(anchorElNav)}
                onClose={handleCloseNavMenu}
                sx={{
                  display: { xs: "block", md: "none" },
                }}
              >
                {pages.map((page, index) => (
                  <Link to={page.link} key={index} className="navbar-links">
                    <MenuItem onClick={handleCloseNavMenu}>
                      <Typography textAlign="center">{page.heading}</Typography>
                    </MenuItem>
                  </Link>
                ))}
              </Menu>
            </Box>
            {
              isLoggedIn ? (
                <Typography
                  variant="h5"
                  noWrap
                  sx={{
                    mr: 2,
                    display: { xs: "flex", md: "none" },
                    flexGrow: 1,
                    fontFamily: "monospace",
                    fontWeight: 700,
                    letterSpacing: ".3rem",
                    color: "inherit",
                    textDecoration: "none",
                  }}
                >
                  <img
                    className="bithappier--header--logo"
                    src={logo}
                    alt="logo"
                  />
                </Typography>
              ) : (
                <Link to="/">
                  <Typography
                    variant="h5"
                    noWrap
                    sx={{
                      mr: 2,
                      display: { xs: "flex", md: "none" },
                      flexGrow: 1,
                      fontFamily: "monospace",
                      fontWeight: 700,
                      letterSpacing: ".3rem",
                      color: "inherit",
                      textDecoration: "none",
                    }}
                  >
                    <img
                      className="bithappier--header--logo"
                      src={logo}
                      alt="logo"
                    />
                  </Typography>
                </Link>
              )
            }
            <Link to="/">
              <Typography
                variant="h5"
                noWrap
                sx={{
                  mr: 2,
                  display: { xs: "flex", md: "none" },
                  flexGrow: 1,
                  fontFamily: "monospace",
                  fontWeight: 700,
                  letterSpacing: ".3rem",
                  color: "inherit",
                  textDecoration: "none",
                }}
              >
                <img
                  className="bithappier--header--logo"
                  src={logo}
                  alt="logo"
                />
              </Typography>
            </Link>
            <Box
              sx={{ flexGrow: 1, display: { xs: "none", md: "flex" } }}
              className="justify-content-end align-items-center"
            >
              {pages.map((page, index) => (
                <Link to={page.link} key={index} className="align-items-center">
                  <Button
                    onClick={handleCloseNavMenu}
                    sx={{ my: 2, color: "white", display: "block" }}
                    className={
                      splitLocation[1] === page.link.split("/")[1]
                        ? "navBar__link--active"
                        : "navBar__link"
                    }
                  >
                    {/* {console.log("pagee", splitLocation[1])} */}
                    {page.heading}
                  </Button>
                </Link>
              ))}
              {accountId ? (
                <>
                  <Link to="/wallet" className="align-items-center d-flex">
                    <div
                      className="d-flex me-4 align-items-center"
                      style={{ textAlign: "initial" }}
                    >
                      <img src={WalletLogo} alt="" srcSet="" width={45} />
                      <div className="d-flex flex-column ms-2 justify-content-center">
                        <span
                          style={{
                            fontFamily: "Inter",
                            fontSize: "12px",
                            fontWeight: "500",
                            color: "#868B90",
                          }}
                        >
                          {accountId}
                        </span>
                        <span
                          style={{
                            fontWeight: "700",
                            height: "28px",
                            fontFamily: "Inter",
                            fontSize: "14px",
                            fontWeight: "400",
                            color: "#000000",
                          }}
                        >
                          {walletBallance ? walletBallance : "-"} NEAR
                        </span>
                        {walletBallance ? (
                          <>
                            {" "}
                            <span
                              style={{
                                color: "#000",
                                fontSize: "10px",
                                marginTop: "-8px",
                                fontWeight: "bold",
                              }}
                            >
                              (
                              {handlePriceWithDecimals(
                                walletBallance * usdAmount
                              )}
                              USD){" "}
                            </span>{" "}
                          </>
                        ) : (
                          "-"
                        )}
                      </div>
                    </div>
                  </Link>
                </>
              ) : (
                <Link to="/connectwallet">
                  <Button
                    onClick={() => {
                      handleCloseNavMenu();
                      handlelogoutOption("Wallet" || "Happiness Wallet");
                    }}
                    sx={{ my: 2, color: "white", display: "block" }}
                    className="navBar__link"
                  >
                    {"Connect wallet"}
                  </Button>
                </Link>
              )}
            </Box>

            <Box sx={{ flexGrow: 0 }} className="d-flex align-items-center">
              <Tooltip title="Profile">
                <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                  {/* <Avatar alt="Remy Sharp" src="/static/images/avatar/2.jpg" /> */}
                  {profileImage ? (
                    <>
                      <img
                        src={profileImage}
                        className="user--avtar--img"
                        alt=""
                        srcSet=""
                      />
                    </>
                  ) : userName ? (
                    <span className="d-flex justify-content-center user--avtar">
                      {userName.slice(0, 1).toUpperCase()}
                    </span>
                  ) : (
                    ""
                  )}
                </IconButton>
              </Tooltip>
              <div className="notification_user_div">
                <span className="header--username" onClick={handleOpenUserMenu}>
                  {userName
                    ? userName.length > 9
                      ? userName.slice(0, 9) + "..."
                      : userName
                    : ""}
                </span>
                {/* {notificationNumber !== '0' && (
                  <Link to="/notification">
                    <span className="notification--icon notify_therapist_profile_icon">
                      {notificationNumber}
                    </span>
                  </Link>
                )} */}
                {!isNotificationPage && notificationNumber !== "0" ? (
                  <Link to="/notification">
                    <span className="notification--icon notify_therapist_profile_icon">
                      {notificationNumber}
                    </span>
                  </Link>
                ) : (
                  ""
                )}
              </div>
              <Menu
                sx={{ mt: "45px" }}
                id="menu-appbar"
                anchorEl={anchorElUser}
                anchorOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                keepMounted
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                open={Boolean(anchorElUser)}
                onClose={handleCloseUserMenu}
              >
                {/* {renderProfileOption()} */}
                {bithappierWallet
                  ? settingsWithGetCredential.map((setting, index) => (
                    <Link
                      to={
                        setting.heading === "Wallet"
                          ? accountId || bithappierWallet
                            ? "/wallet"
                            : setting.link
                          : setting.link
                      }
                      key={index}
                      className="navbar-links"
                      onClick={() => {
                        handlelogoutOption(setting.heading);
                      }}
                    >
                      <MenuItem
                        // onClick={handleCloseUserMenu}
                        onClick={(e) => {
                          handleGetCredential(e, setting.heading);
                          handleCloseUserMenu();
                        }}
                        className="menu--item--header"
                      >
                        <Typography
                          // onClick={(e) => {
                          //   handleGetCredential(e, setting.heading);
                          // }}
                          textAlign="center"
                        >
                          <div
                            dangerouslySetInnerHTML={{
                              __html: setting.heading,
                            }}
                          />
                        </Typography>
                      </MenuItem>
                    </Link>
                  ))
                  : settingsWithOutGetCredential.map((setting, index) => (
                    <Link
                      to={
                        setting.heading === "Wallet"
                          ? accountId || bithappierWallet
                            ? "/wallet"
                            : setting.link
                          : setting.link
                      }
                      key={index}
                      className="navbar-links"
                      onClick={() => {
                        handlelogoutOption(setting.heading);
                      }}
                    >
                      <MenuItem
                        onClick={handleCloseUserMenu}
                        className="menu--item--header"
                      >
                        <Typography textAlign="center">
                          <div
                            dangerouslySetInnerHTML={{
                              __html: setting.heading,
                            }}
                          />
                        </Typography>
                      </MenuItem>
                    </Link>
                  ))}
                {/* <MenuItem onClick={handleCloseUserMenu}>
                  <Typography
                    textAlign="center"
                    onClick={() => {
                      handleLogout();
                    }}
                  >
                    {"Log out"}
                  </Typography>
                </MenuItem> */}
              </Menu>
            </Box>
          </Toolbar>
        </Container>
      </AppBar>
    </>
  );
};

export default ProfessionalHeader;
